/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface LabelGroup
 */
export interface LabelGroup {
  /**
   *
   * @type {string}
   * @memberof LabelGroup
   */
  labelGroupId?: string;
  /**
   *
   * @type {string}
   * @memberof LabelGroup
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof LabelGroup
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof LabelGroup
   */
  color?: string;
}

/**
 * Check if a given object implements the LabelGroup interface.
 */
export function instanceOfLabelGroup(value: object): value is LabelGroup {
  return true;
}

export function LabelGroupFromJSON(json: any): LabelGroup {
  return LabelGroupFromJSONTyped(json, false);
}

export function LabelGroupFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): LabelGroup {
  if (json == null) {
    return json;
  }
  return {
    labelGroupId:
      json["labelGroupId"] == null ? undefined : json["labelGroupId"],
    title: json["title"] == null ? undefined : json["title"],
    description: json["description"] == null ? undefined : json["description"],
    color: json["color"] == null ? undefined : json["color"],
  };
}

export function LabelGroupToJSON(json: any): LabelGroup {
  return LabelGroupToJSONTyped(json, false);
}

export function LabelGroupToJSONTyped(
  value?: LabelGroup | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    labelGroupId: value["labelGroupId"],
    title: value["title"],
    description: value["description"],
    color: value["color"],
  };
}
